export const caliForniaCountyList = [
  {
    County: "Alameda County",
    name: "Alameda, CA",
    value: "Alameda, CA",
    State: "California",
  },
  {
    County: "Alpine County",
    name: "Alpine, CA",
    value: "Alpine, CA",
    State: "California",
  },
  {
    County: "Amador County",
    name: "Amador, CA",
    value: "Amador, CA",
    State: "California",
  },
  {
    County: "Butte County",
    name: "Butte, CA",
    value: "Butte, CA",
    State: "California",
  },
  {
    County: "Calaveras County",
    name: "Calaveras, CA",
    value: "Calaveras, CA",
    State: "California",
  },
  {
    County: "Colusa County",
    name: "Colusa, CA",
    value: "Colusa, CA",
    State: "California",
  },
  {
    County: "Contra Costa County",
    name: "Contra Costa, CA",
    value: "Contra Costa, CA",
    State: "California",
  },
  {
    County: "Del Norte County",
    name: "Del Norte, CA",
    value: "Del Norte, CA",
    State: "California",
  },
  {
    County: "El Dorado County",
    name: "El Dorado, CA",
    value: "El Dorado, CA",
    State: "California",
  },
  {
    County: "Fresno County",
    name: "Fresno, CA",
    value: "Fresno, CA",
    State: "California",
  },
  {
    County: "Glenn County",
    name: "Glenn, CA",
    value: "Glenn, CA",
    State: "California",
  },
  {
    County: "Humboldt County",
    name: "Humboldt, CA",
    value: "Humboldt, CA",
    State: "California",
  },
  {
    County: "Imperial County",
    name: "Imperial, CA",
    value: "Imperial, CA",
    State: "California",
  },
  {
    County: "Inyo County",
    name: "Inyo, CA",
    value: "Inyo, CA",
    State: "California",
  },
  {
    County: "Kern County",
    name: "Kern, CA",
    value: "Kern, CA",
    State: "California",
  },
  {
    County: "Kings County",
    name: "Kings, CA",
    value: "Kings, CA",
    State: "California",
  },
  {
    County: "Lake County",
    name: "Lake, CA",
    value: "Lake, CA",
    State: "California",
  },
  {
    County: "Lassen County",
    name: "Lassen, CA",
    value: "Lassen, CA",
    State: "California",
  },
  {
    County: "Los Angeles County",
    name: "Los Angeles, CA",
    value: "Los Angeles, CA",
    State: "California",
  },
  {
    County: "Madera County",
    name: "Madera, CA",
    value: "Madera, CA",
    State: "California",
  },
  {
    County: "Marin County",
    name: "Marin, CA",
    value: "Marin, CA",
    State: "California",
  },
  {
    County: "Mariposa County",
    name: "Mariposa, CA",
    value: "Mariposa, CA",
    State: "California",
  },
  {
    County: "Mendocino County",
    name: "Mendocino, CA",
    value: "Mendocino, CA",
    State: "California",
  },
  {
    County: "Merced County",
    name: "Merced, CA",
    value: "Merced, CA",
    State: "California",
  },
  {
    County: "Modoc County",
    name: "Modoc, CA",
    value: "Modoc, CA",
    State: "California",
  },
  {
    County: "Mono County",
    name: "Mono, CA",
    value: "Mono, CA",
    State: "California",
  },
  {
    County: "Monterey County",
    name: "Monterey, CA",
    value: "Monterey, CA",
    State: "California",
  },
  {
    County: "Napa County",
    name: "Napa, CA",
    value: "Napa, CA",
    State: "California",
  },
  {
    County: "Nevada County",
    name: "Nevada, CA",
    value: "Nevada, CA",
    State: "California",
  },
  {
    County: "Orange County",
    name: "Orange, CA",
    value: "Orange, CA",
    State: "California",
  },
  {
    County: "Placer County",
    name: "Placer, CA",
    value: "Placer, CA",
    State: "California",
  },
  {
    County: "Plumas County",
    name: "Plumas, CA",
    value: "Plumas, CA",
    State: "California",
  },
  {
    County: "Riverside County",
    name: "Riverside, CA",
    value: "Riverside, CA",
    State: "California",
  },
  {
    County: "Sacramento County",
    name: "Sacramento, CA",
    value: "Sacramento, CA",
    State: "California",
  },
  {
    County: "San Benito County",
    name: "San Benito, CA",
    value: "San Benito, CA",
    State: "California",
  },
  {
    County: "San Bernardino County",
    name: "San Bernardino, CA",
    value: "San Bernardino, CA",
    State: "California",
  },
  {
    County: "San Diego County",
    name: "San Diego, CA",
    value: "San Diego, CA",
    State: "California",
  },
  {
    County: "San Francisco, City and County of",
    name: "San Francisco City, CA",
    value: "San Francisco City, CA",
    State: "California",
  },
  {
    County: "San Joaquin County",
    name: "San Joaquin, CA",
    value: "San Joaquin, CA",
    State: "California",
  },
  {
    County: "San Luis Obispo County",
    name: "San Luis Obispo, CA",
    value: "San Luis Obispo, CA",
    State: "California",
  },
  {
    County: "San Mateo County",
    name: "San Mateo, CA",
    value: "San Mateo, CA",
    State: "California",
  },
  {
    County: "Santa Barbara County",
    name: "Santa Barbara, CA",
    value: "Santa Barbara, CA",
    State: "California",
  },
  {
    County: "Santa Clara County",
    name: "Santa Clara, CA",
    value: "Santa Clara, CA",
    State: "California",
  },
  {
    County: "Santa Cruz County",
    name: "Santa Cruz, CA",
    value: "Santa Cruz, CA",
    State: "California",
  },
  {
    County: "Shasta County",
    name: "Shasta, CA",
    value: "Shasta, CA",
    State: "California",
  },
  {
    County: "Sierra County",
    name: "Sierra, CA",
    value: "Sierra, CA",
    State: "California",
  },
  {
    County: "Siskiyou County",
    name: "Siskiyou, CA",
    value: "Siskiyou, CA",
    State: "California",
  },
  {
    County: "Solano County",
    name: "Solano, CA",
    value: "Solano, CA",
    State: "California",
  },
  {
    County: "Sonoma County",
    name: "Sonoma, CA",
    value: "Sonoma, CA",
    State: "California",
  },
  {
    County: "Stanislaus County",
    name: "Stanislaus, CA",
    value: "Stanislaus, CA",
    State: "California",
  },
  {
    County: "Sutter County",
    name: "Sutter, CA",
    value: "Sutter, CA",
    State: "California",
  },
  {
    County: "Tehama County",
    name: "Tehama, CA",
    value: "Tehama, CA",
    State: "California",
  },
  {
    County: "Trinity County",
    name: "Trinity, CA",
    value: "Trinity, CA",
    State: "California",
  },
  {
    County: "Tulare County",
    name: "Tulare, CA",
    value: "Tulare, CA",
    State: "California",
  },
  {
    County: "Tuolumne County",
    name: "Tuolumne, CA",
    value: "Tuolumne, CA",
    State: "California",
  },
  {
    County: "Ventura County",
    name: "Ventura, CA",
    value: "Ventura, CA",
    State: "California",
  },
  {
    County: "Yolo County",
    name: "Yolo, CA",
    value: "Yolo, CA",
    State: "California",
  },
  {
    County: "Yuba County",
    name: "Yuba, CA",
    value: "Yuba, CA",
    State: "California",
  },
];

export const floridaCountyList = [
  {
    County: "Alachua County",
    name: "Alachua, FL",
    value: "Alachua, FL",
    State: "Florida",
  },
  {
    County: "Baker County",
    name: "Baker, FL",
    value: "Baker, FL",
    State: "Florida",
  },
  {
    County: "Bay County",
    name: "Bay, FL",
    value: "Bay, FL",
    State: "Florida",
  },
  {
    County: "Bradford County",
    name: "Bradford, FL",
    value: "Bradford, FL",
    State: "Florida",
  },
  {
    County: "Brevard County",
    name: "Brevard, FL",
    value: "Brevard, FL",
    State: "Florida",
  },
  {
    County: "Broward County",
    name: "Broward, FL",
    value: "Broward, FL",
    State: "Florida",
  },
  {
    County: "Calhoun County",
    name: "Calhoun, FL",
    value: "Calhoun, FL",
    State: "Florida",
  },
  {
    County: "Charlotte County",
    name: "Charlotte, FL",
    value: "Charlotte, FL",
    State: "Florida",
  },
  {
    County: "Citrus County",
    name: "Citrus, FL",
    value: "Citrus, FL",
    State: "Florida",
  },
  {
    County: "Clay County",
    name: "Clay, FL",
    value: "Clay, FL",
    State: "Florida",
  },
  {
    County: "Collier County",
    name: "Collier, FL",
    value: "Collier, FL",
    State: "Florida",
  },
  {
    County: "Columbia County",
    name: "Columbia, FL",
    value: "Columbia, FL",
    State: "Florida",
  },
  {
    County: "DeSoto County",
    name: "DeSoto, FL",
    value: "DeSoto, FL",
    State: "Florida",
  },
  {
    County: "Dixie County",
    name: "Dixie, FL",
    value: "Dixie, FL",
    State: "Florida",
  },
  {
    County: "Duval County",
    name: "Duval, FL",
    value: "Duval, FL",
    State: "Florida",
  },
  {
    County: "Escambia County",
    name: "Escambia, FL",
    value: "Escambia, FL",
    State: "Florida",
  },
  {
    County: "Flagler County",
    name: "Flagler, FL",
    value: "Flagler, FL",
    State: "Florida",
  },
  {
    County: "Franklin County",
    name: "Franklin, FL",
    value: "Franklin, FL",
    State: "Florida",
  },
  {
    County: "Gadsden County",
    name: "Gadsden, FL",
    value: "Gadsden, FL",
    State: "Florida",
  },
  {
    County: "Gilchrist County",
    name: "Gilchrist, FL",
    value: "Gilchrist, FL",
    State: "Florida",
  },
  {
    County: "Glades County",
    name: "Glades, FL",
    value: "Glades, FL",
    State: "Florida",
  },
  {
    County: "Gulf County",
    name: "Gulf, FL",
    value: "Gulf, FL",
    State: "Florida",
  },
  {
    County: "Hamilton County",
    name: "Hamilton, FL",
    value: "Hamilton, FL",
    State: "Florida",
  },
  {
    County: "Hardee County",
    name: "Hardee, FL",
    value: "Hardee, FL",
    State: "Florida",
  },
  {
    County: "Hendry County",
    name: "Hendry, FL",
    value: "Hendry, FL",
    State: "Florida",
  },
  {
    County: "Hernando County",
    name: "Hernando, FL",
    value: "Hernando, FL",
    State: "Florida",
  },
  {
    County: "Highlands County",
    name: "Highlands, FL",
    value: "Highlands, FL",
    State: "Florida",
  },
  {
    County: "Hillsborough County",
    name: "Hillsborough, FL",
    value: "Hillsborough, FL",
    State: "Florida",
  },
  {
    County: "Holmes County",
    name: "Holmes, FL",
    value: "Holmes, FL",
    State: "Florida",
  },
  {
    County: "Indian River County",
    name: "Indian River, FL",
    value: "Indian River, FL",
    State: "Florida",
  },
  {
    County: "Jackson County",
    name: "Jackson, FL",
    value: "Jackson, FL",
    State: "Florida",
  },
  {
    County: "Jefferson County",
    name: "Jefferson, FL",
    value: "Jefferson, FL",
    State: "Florida",
  },
  {
    County: "Lafayette County",
    name: "Lafayette, FL",
    value: "Lafayette, FL",
    State: "Florida",
  },
  {
    County: "Lake County",
    name: "Lake, FL",
    value: "Lake, FL",
    State: "Florida",
  },
  {
    County: "Lee County",
    name: "Lee, FL",
    value: "Lee, FL",
    State: "Florida",
  },
  {
    County: "Leon County",
    name: "Leon, FL",
    value: "Leon, FL",
    State: "Florida",
  },
  {
    County: "Levy County",
    name: "Levy, FL",
    value: "Levy, FL",
    State: "Florida",
  },
  {
    County: "Liberty County",
    name: "Liberty, FL",
    value: "Liberty, FL",
    State: "Florida",
  },
  {
    County: "Madison County",
    name: "Madison, FL",
    value: "Madison, FL",
    State: "Florida",
  },
  {
    County: "Manatee County",
    name: "Manatee, FL",
    value: "Manatee, FL",
    State: "Florida",
  },
  {
    County: "Marion County",
    name: "Marion, FL",
    value: "Marion, FL",
    State: "Florida",
  },
  {
    County: "Martin County",
    name: "Martin, FL",
    value: "Martin, FL",
    State: "Florida",
  },
  {
    County: "Miami-Dade County",
    name: "Miami-Dade, FL",
    value: "Miami-Dade, FL",
    State: "Florida",
  },
  {
    County: "Monroe County",
    name: "Monroe, FL",
    value: "Monroe, FL",
    State: "Florida",
  },
  {
    County: "Nassau County",
    name: "Nassau, FL",
    value: "Nassau, FL",
    State: "Florida",
  },
  {
    County: "Okaloosa County",
    name: "Okaloosa, FL",
    value: "Okaloosa, FL",
    State: "Florida",
  },
  {
    County: "Okeechobee County",
    name: "Okeechobee, FL",
    value: "Okeechobee, FL",
    State: "Florida",
  },
  {
    County: "Orange County",
    name: "Orange, FL",
    value: "Orange, FL",
    State: "Florida",
  },
  {
    County: "Osceola County",
    name: "Osceola, FL",
    value: "Osceola, FL",
    State: "Florida",
  },
  {
    County: "Palm Beach County",
    name: "Palm Beach, FL",
    value: "Palm Beach, FL",
    State: "Florida",
  },
  {
    County: "Pasco County",
    name: "Pasco, FL",
    value: "Pasco, FL",
    State: "Florida",
  },
  {
    County: "Pinellas County",
    name: "Pinellas, FL",
    value: "Pinellas, FL",
    State: "Florida",
  },
  {
    County: "Polk County",
    name: "Polk, FL",
    value: "Polk, FL",
    State: "Florida",
  },
  {
    County: "Putnam County",
    name: "Putnam, FL",
    value: "Putnam, FL",
    State: "Florida",
  },
  {
    County: "St. Johns County",
    name: "St. Johns, FL",
    value: "St. Johns, FL",
    State: "Florida",
  },
  {
    County: "St. Lucie County",
    name: "St. Lucie, FL",
    value: "St. Lucie, FL",
    State: "Florida",
  },
  {
    County: "Santa Rosa County",
    name: "Santa Rosa, FL",
    value: "Santa Rosa, FL",
    State: "Florida",
  },
  {
    County: "Sarasota County",
    name: "Sarasota, FL",
    value: "Sarasota, FL",
    State: "Florida",
  },
  {
    County: "Seminole County",
    name: "Seminole, FL",
    value: "Seminole, FL",
    State: "Florida",
  },
  {
    County: "Sumter County",
    name: "Sumter, FL",
    value: "Sumter, FL",
    State: "Florida",
  },
  {
    County: "Suwannee County",
    name: "Suwannee, FL",
    value: "Suwannee, FL",
    State: "Florida",
  },
  {
    County: "Taylor County",
    name: "Taylor, FL",
    value: "Taylor, FL",
    State: "Florida",
  },
  {
    County: "Union County",
    name: "Union, FL",
    value: "Union, FL",
    State: "Florida",
  },
  {
    County: "Volusia County",
    name: "Volusia, FL",
    value: "Volusia, FL",
    State: "Florida",
  },
  {
    County: "Wakulla County",
    name: "Wakulla, FL",
    value: "Wakulla, FL",
    State: "Florida",
  },
  {
    County: "Walton County",
    name: "Walton, FL",
    value: "Walton, FL",
    State: "Florida",
  },
  {
    County: "Washington County",
    name: "Washington, FL",
    value: "Washington, FL",
    State: "Florida",
  },
];

export const countyList: any = {
  none: [...caliForniaCountyList, ...floridaCountyList],
  CA: caliForniaCountyList,
  FL: floridaCountyList,
};

export const californiaState = [{ name: "California", value: "CA" }];
export const floridaState = [{ name: "Florida", value: "FL" }];

export const stateList: any = {
  Approved: {
    none: [...californiaState, ...floridaState],
    FL: floridaState,
    CA: californiaState,
  },
  Suspended: {
    none: [...floridaState],
    FL: floridaState,
    CA: [],
  },
  Temiinated: {
    none: [...floridaState],
    FL: floridaState,
    CA: [],
  },
};

const caProjectList = [
  {
    name: "Electrical Vehicle Charging Station",
    value: "Electrical Vehicle Charging Station",
  },
  {
    name: "Energy Storage",
    value: "Energy Storage",
  },
  {
    name: "Exterior Coating/Painting",
    value: "Exterior Coating/Painting",
  },
  {
    name: "Fuel Cells",
    value: "Fuel Cells",
  },
  {
    name: "Heating, Ventilation, and Air Conditioning",
    value: "Heating, Ventilation, and Air Conditioning",
  },
  {
    name: "Insulation and Air Sealing",
    value: "Insulation and Air Sealing",
  },
  {
    name: "Plumbing",
    value: "Plumbing",
  },
  {
    name: "Pool Equipment",
    value: "Pool Equipment",
  },
  {
    name: "Roofing and Siding",
    value: "Roofing and Siding",
  },
  {
    name: "Solar Electricity",
    value: "Solar Electricity",
  },
  {
    name: "Solar Water Heating",
    value: "Solar Water Heating",
  },
  {
    name: "Water Heating",
    value: "Water Heating",
  },
  {
    name: "Windows and Doors",
    value: "Windows and Doors",
  },
];

const flProjectList = [
  {
    name: "Appliances",
    value: "Appliances",
  },
  {
    name: "Electrical Vehicle Charging Station",
    value: "Electrical Vehicle Charging Station",
  },
  {
    name: "Energy Storage",
    value: "Energy Storage",
  },
  {
    name: "Exterior Coating/Painting",
    value: "Exterior Coating/Painting",
  },
  {
    name: "Flood Mitigation",
    value: "Flood Mitigation",
  },
  {
    name: "Fuel Cells",
    value: "Fuel Cells",
  },
  {
    name: "Heating, Ventilation, and Air Conditioning",
    value: "Heating, Ventilation, and Air Conditioning",
  },
  {
    name: "Insulation and Air Sealing",
    value: "Insulation and Air Sealing",
  },
  {
    name: "Plumbing",
    value: "Plumbing",
  },
  {
    name: "Pool Equipment",
    value: "Pool Equipment",
  },
  {
    name: "Roofing and Siding",
    value: "Roofing and Siding",
  },
  {
    name: "Sewer/Septic",
    value: "Sewer/Septic",
  },
  {
    name: "Solar Electricity",
    value: "Solar Electricity",
  },
  {
    name: "Solar Water Heating",
    value: "Solar Water Heating",
  },
  {
    name: "Storm Retrofit",
    value: "Storm Retrofit",
  },
  {
    name: "Water Heating",
    value: "Water Heating",
  },
  {
    name: "Windows and Doors",
    value: "Windows and Doors",
  },
];

export const projectList: any = {
  none: [
    {
      name: "Please Select State or County",
      value: "Please Select State or County",
    },
  ],
  CA: caProjectList,
  FL: flProjectList,
};

const caContractorStatus = [
  {
    name: "Approved",
    value: "Approved",
  },
];

const flContractorStatus = [
  {
    name: "Approved",
    value: "Approved",
  },
  {
    name: "Suspended",
    value: "Suspended",
  },
  {
    name: "Temiinated",
    value: "Temiinated",
  },
];

export const contractorStatusData: any = {
  none: [
    {
      name: "Approved",
      value: "Approved",
    },
    {
      name: "Suspended",
      value: "Suspended",
    },
    {
      name: "Temiinated",
      value: "Temiinated",
    },
  ],
  CA: caContractorStatus,
  FL: flContractorStatus,
};
